import styled from 'styled-components'

export default styled.p<{ fontSize?: string }>`
  color: ${({ theme }) => theme.palette.common.red};
  font-size: ${({ fontSize }) => fontSize || 'inherit'};
`
